import { useState } from 'react'
import CircularProgress from '@material-ui/core/CircularProgress'

import { Alerts, ModalDel } from '../../../components'

import SC from './styled.activity'
import Funcs from './functions.activity'
import constants, { SR_STATUS } from './constants.activity'
import AddEquipmentTaskModal from './add-task'
import FC from './factory-components.activity'
import AddDocumentModal from './add-document'
import AddTaskModal from './add-task-modal/main.add-task.js'

const ActivityModal = ({ dataAll, inEditMode }) => {
  const { Location, Code } = dataAll
  const [task, setTask] = useState({})
  const [activity, setActivity] = useState({})
  const [isLoading, setIsLoading] = useState(true)
  const [toggleDelete, setToggleDelete] = useState(false)
  const [showModalDoc, setShowModalDoc] = useState({
    isOpen: false,
    task: undefined,
    taskCode: undefined,
    activityCode: undefined,
  })
  const [showModalTask, setShowModalTask] = useState({
    isOpen: false,
    activity: undefined,
    location: undefined,
  })
  const [showModalStatus, setShowModalStatus] = useState(constants.showModalStatus)
  const [showAlert, setShowAlert] = useState({ visible: false, msg: '', success: false, type: '' })

  const [activityList, setActivityList, fetchData] = Funcs.useFetchActivityBySRCode(Code, Location, setIsLoading)

  const addNewTask = Funcs.addNewTaskHOF(Location, setActivityList, setIsLoading, setShowModalTask)
  const handleOpenTaskDetail = Funcs.handleOpenTaskDetailHOF(activityList, setActivityList)
  const handleOpenActivityDetail = Funcs.handleOpenActivityDetailHOF(activityList, setActivityList)
  const updateActivityAndTaskHeader = Funcs.updateActivityAndTaskHeaderHOF(activityList, setActivityList, Location)
  const toggleModal = Funcs.toggleModalHOF(Code, Location, showModalStatus.isOpen, setShowModalStatus, setIsLoading, setActivityList)
  const toggleModalDoc = Funcs.toggleModalDocHOF(showModalDoc.isOpen, setShowModalDoc)
  const toggleModalTask = Funcs.toggleModalTaskHOF(Location, showModalTask.isOpen, setShowModalTask)
  const deleteTask = Funcs.deleteTaskHOF(Location, setActivityList, activity, task, setToggleDelete, setShowAlert, setIsLoading)

  const handleRemoveModal = () => (
    <div>
      <ModalDel
        id='m_actv_delete_mdl'
        toggleDialog={() => setToggleDelete(!toggleDelete)}
        submitDelete={deleteTask}
        deleteText='Are you sure to delete the data ?'
      />
    </div>
  )

  const deleteData = (act, ts) => {
    setTask(ts)
    setActivity(act)
    setToggleDelete(!toggleDelete)
  }

  return (
    <SC.Container>
      {toggleDelete && handleRemoveModal()}
      {isLoading ? (
        <SC.CircularProgressWrapper>
          <CircularProgress />
        </SC.CircularProgressWrapper>
      ) : (
        <FC.ActivityGrid
          location={Location}
          data={activityList}
          inEditMode={inEditMode}
          getColor={Funcs.getStatusColor}
          setActivityList={setActivityList}
          addNewTask={addNewTask}
          deleteTask={deleteData}
          handleShowModal={toggleModal}
          handleOpenTask={handleOpenTaskDetail}
          handleShowModalDoc={toggleModalDoc}
          handleShowModalTask={toggleModalTask}
          handleOpenActivity={handleOpenActivityDetail}
          isFinalized={dataAll.Sr_Status === SR_STATUS.FINALIZED}
          updateActivityAndTaskHeader={updateActivityAndTaskHeader}
          isActivityChecklist={dataAll.Activity_Type === 'Checklist'}
        />
      )}
      {showModalDoc.isOpen && (
        <AddDocumentModal
          inEditMode={inEditMode}
          handleClose={toggleModalDoc}
          taskCode={showModalDoc.taskCode}
          dataSr={dataAll}
          activityCode={showModalDoc.activityCode}
          data={showModalDoc?.task?.progress_task_attachment_list || []}
          getActivity={fetchData}
        />
      )}
      {showModalStatus.isOpen && (
        <AddEquipmentTaskModal
          dataAll={dataAll}
          srCode={dataAll.Code}
          inEditMode={inEditMode}
          handleClose={toggleModal}
          setShowAlert={setShowAlert}
          activityList={activityList}
          showModalStatus={showModalStatus}
        />
      )}
      {showModalTask.isOpen && (
        <AddTaskModal
          addNewTask={addNewTask}
          activity={showModalTask.activity}
          location={showModalTask.location}
          handleClose={toggleModalTask}
          setActivityList={setActivityList}
          setIsLoading={setIsLoading}
          refetch={Funcs.fetchActivityData}
        />
      )}
      <Alerts
        type={showAlert.type}
        msg={showAlert.msg}
        close={() => {
          setShowAlert({ ...showAlert, visible: false })
        }}
        open={showAlert.visible}
        success={showAlert.success}
      />
    </SC.Container>
  )
}

export default ActivityModal